import { helpers } from '@vuelidate/validators';

export const isTrueRule = helpers.withMessage(
  'Should be checked',
  (value: boolean) => value,
);
